import { formatBasicMeetingHeader } from './generateMeetingAgenda';

export type CreateMeetingGoogleDocParams = {
  spaceId: string;
  title: string;
  content?: string | null;
  startTime?: string;
  uploadFiles: (params: {
    files: File[];
    spaceId: string;
    folderName?: string;
    convertToDoc?: boolean;
  }) => Promise<Array<{ fileId: string; viewUrl: string }>>;
};

export async function createMeetingGoogleDoc(
  params: CreateMeetingGoogleDocParams
): Promise<string> {
  const docContent =
    params.content?.trim() ||
    formatBasicMeetingHeader({
      title: params.title,
      meetingDate: params.startTime,
    });

  const htmlDocument = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${params.title}</title>
</head>
<body>
  ${docContent}
</body>
</html>`;

  const docFile = new File([htmlDocument], `${params.title}.html`, {
    type: 'text/html;charset=utf-8',
  });

  const uploadResults = await params.uploadFiles({
    files: [docFile],
    spaceId: params.spaceId,
    folderName: 'Réunions',
    convertToDoc: true,
  });

  const uploaded = uploadResults[0];
  if (!uploaded || (!uploaded.fileId && !uploaded.viewUrl)) {
    throw new Error("Impossible de créer le document Google Docs dans le dossier « Réunions ».");
  }

  return uploaded.fileId
    ? `https://docs.google.com/document/d/${uploaded.fileId}/edit`
    : uploaded.viewUrl;
}

